export enum MeasureUnitKey {
  DIMENSION = 'dimensionUnit',
  WEIGHT = 'weightUnit',
  VOLUME = 'volumeUnit',
}
